<label
	class="rounded-top rounded-bottom"
	[class.no-btn]="no"
	[class.toggle-btn]="!no"
	[title]="noTitle"
>
	<input
		class="d-none"
		type="checkbox"
		[disabled]="disabled || disableNo"
		(click)="changeValue('no')"
	/>
	<i
		aria-hidden="true"
		class="fa-circle-xmark"
		[class.far]="!no"
		[class.fas]="no"
		[class.text-muted]="disabled || disableNo"
	></i>
</label>
<label
	class="toggle-btn rounded-top rounded-bottom"
	[class.bg-info]="yes"
	[class.text-white]="yes"
	[title]="yesTitle"
>
	<input
		class="d-none"
		type="checkbox"
		[disabled]="disabled || disableYes"
		(click)="changeValue('yes')"
	/>
	<i
		aria-hidden="true"
		class="fa-circle-check"
		[class.far]="!yes"
		[class.fas]="yes"
		[class.text-muted]="disabled || disableYes"
	></i>
</label>
